import React from "react";
import { track } from "../utils/analytics";

/** Inline start-free-trial CTA, shown when the free tier's AI refinement is
 * locked/exhausted or the daily sentence quota is spent. Shared by the Iʿrāb
 * panel (overlay + public page) and the PDF reader's Iʿrāb mode. */
export default function IrabUpsell({ kind, retryAt, subscriberDaily, context }) {
  const hasToken = !!localStorage.getItem("token");
  const headline = kind === "quota"
    ? "You've used today's free sentences"
    : "Unlock the AI-checked iʿrāb";
  const allowance = subscriberDaily ? `${subscriberDaily} sentences a day` : "a much bigger daily allowance";
  const body = kind === "quota"
    ? `Start your free trial and keep going instantly — ${allowance}, every word AI-checked. No card required.`
    : "Your instant analysis is free every day. Subscribers get every word verified by AI — full roles, reasons, and unlimited refinement on their plan.";
  let resetNote = "";
  if (kind === "quota" && retryAt) {
    try {
      const when = new Date(retryAt).toLocaleString([], {
        weekday: "short", day: "numeric", month: "short",
        hour: "numeric", minute: "2-digit",
      });
      resetNote = `Prefer to wait? Your free sentences reset ${when}.`;
    } catch { /* unparseable date — just omit the note */ }
  }
  const go = () => {
    track("irab-signup-click", { context, kind });
    window.location.assign(hasToken ? "/" : "/?signup=1");
  };
  return (
    <div className="mx-5 mt-3 px-4 py-3.5 rounded-xl shrink-0 flex flex-col sm:flex-row sm:items-center gap-3"
      style={{ background: "var(--tag-violet-bg)", border: "1px solid var(--panel-line)" }}>
      <div className="flex-1">
        <p className="text-sm font-semibold text-dt-parchment">{headline}</p>
        <p className="text-xs text-dt-parchment-dim mt-0.5">{body}</p>
        {resetNote && <p className="text-[11px] text-dt-parchment-dim mt-1 opacity-75">{resetNote}</p>}
      </div>
      <button
        onClick={go}
        className="shrink-0 px-4 py-2 rounded-xl bg-dt-gold text-dt-ink hover:brightness-105 text-sm font-semibold transition-[filter]"
      >
        Start your 7-day free trial
      </button>
    </div>
  );
}
